import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ModalController, ToastController } from 'ionic-angular';
import { CongresoPage } from '../congreso/congreso';
import { PonentesPage } from '../ponentes/ponentes';
import { ProgramaPage } from '../programa/programa';
import { CongresoEditPage } from '../congreso-edit/congreso-edit';
import { GlobalProvider } from '../../providers/global/global';
import { PresentacionEditPage } from '../presentacion-edit/presentacion-edit';
import { MenuProvider } from '../../providers/menu/menu';
import { ImagenesProvider } from '../../providers/imagenes/imagenes';
import { PonentesProvider } from '../../providers/ponentes/ponentes';
import { ProgramaProvider } from '../../providers/programa/programa';
import { IndicadoresProvider } from '../../providers/indicadores/indicadores';
import { Chart } from 'chart.js';
import { CongresosProvider } from '../../providers/congresos/congresos';
/**
 * Generated class for the PanelPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage(
  { name: 'page-panel',
  segment: 'panel' }
)
@Component({
  selector: 'page-panel',
  templateUrl: 'panel.html',
})

export class PanelPage {
  @ViewChild('barCanvas1') barCanvas1;
  @ViewChild('doughnutCanvas') doughnutCanvas;
  @ViewChild('lineCanvas') lineCanvas;

  barChart: any;
  doughnutChart: any;
  lineChart: any;
  public congresoactivo;
  public misponentes = [];
  public miprograma = [];
  public misindicadores = [];
public item;
  public doughnutChartLabels: string[] = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
  public doughnutChartData: number[] = [350, 450, 100];
  public doughnutChartType: string = 'doughnut';
  /*public barChartOptions:any = {
    scales: { yAxes: [{ticks: {
    fontSize: 13,
    mirror: true}}] } ,
    scaleShowVerticalLines: true,
    responsive: true
  };*/
  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };

  public barChartLabels:string[] = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
 // public barChartType:string = 'horizontalBar';
 public barChartType:string = 'bar';
  public barChartLegend:boolean = false;
  
  public barChartData:any[] = [
    {data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A'}
  ];
  constructor(public congresoprovider: CongresosProvider,public toastCtrl: ToastController,public imagenes: ImagenesProvider, public indicadoresProvider: IndicadoresProvider,
    public ponentesProvider: PonentesProvider, public programaProvider: ProgramaProvider, public menuProvider: MenuProvider, public global: GlobalProvider, public menu: MenuController, public modalCtrl: ModalController, public navCtrl: NavController, public navParams: NavParams) {
    this.menu.enable(true);
    this.item = navParams.get('item');
    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%');
    console.log(this.item);
    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%');
    this.congresoactivo = navParams.get("congreso");
    
    this.global.congresomenu = this.congresoactivo;

    this.menuProvider.allfiltro(this.global.congresomenu.clave, 0).subscribe(data => {
      this.global.menuglobal = data;

    })
    this.cargaindicadores();
    this.cargaresultados();
    //   this.cargaponentes();
    //  this.cargaprograma();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PanelPage');
  }
  preview() {
    let url = '';
    url = this.global.web + "previa?id=" + this.global.congresomenu.nombre;
    window.open(url, '_system', 'location=yes');
  }
  cargaindicadores() {
    this.indicadoresProvider.all(this.global.congresomenu.clave).subscribe(indicador => {
      this.misindicadores = indicador;
      console.log(this.misindicadores);

    })
  }
  editarpresentacion() {

    let myModal = this.modalCtrl.create('page-presentacion-edit', { 'congresoactivo': this.global.congresomenu }, { cssClass: this.global.nombretema });
    myModal.present();

    myModal.onDidDismiss(data => {

    });


    //this.navCtrl.push(CongresoEditPage, {congresoactivo: this.congresoactivo});
  }
  editarcongreso() {

    let myModal = this.modalCtrl.create('page-congreso-edit', { 'congresoactivo': this.global.congresomenu, 'accion': 'UPDATE' }, { cssClass: this.global.nombretema });
    myModal.present();

    myModal.onDidDismiss(data => {
      //this.datos_pruebas.pistas.push(data);
      //this.cargaprograma();      
    });


    //this.navCtrl.push(CongresoEditPage, {congresoactivo: this.congresoactivo});
  }
  cargaponentes() {
    this.misponentes = this.ponentesProvider.listaponentes;
    this.ponentesProvider.allponentes(this.global.congresomenu.clave).subscribe(data => {
      this.misponentes = data;


      var length = this.misponentes.length;
      for (var i = 0; i < length; i++) {
        var im = this.misponentes[i].imagen;
        if (im != null) {
          this.imagenes.convierte2(this.global.congresomenu.clave, this.misponentes[i].imagen, i).subscribe(data => {
            this.misponentes[data.id].imagen = data.imagen;

            window.localStorage.setItem('ponentestemp', JSON.stringify(this.misponentes));
          })
        }

      };


      ////////////////////
    })
  }
  cargaprograma() {
    this.programaProvider.all(this.global.congresomenu.clave).subscribe(programa => {
      this.miprograma = programa;
      window.localStorage.setItem('programatemp', JSON.stringify(this.miprograma));

    })
  }


  irmenu(act) {
    var opcion = act.opcion;
    if (opcion == 1) {
      this.editarpresentacion();
    } else if (opcion == 2) {
      this.paginaponentes(act);
    } else if (opcion == 3) {
      this.paginaprograma(act);
    } else if (opcion == 4) {
      this.paginadocumentos(act);
    } else if (opcion == 5) {
      this.paginalinks(act);
    } else if (opcion == 6) {
      this.paginaencuesta(act);
    }else if (opcion == 17) {
      this.paginaencuestacab(act);
    } else if (opcion == 7) {
      this.paginapreguntas(act);
    } else if (opcion == 8) {
      this.paginapatrocinadores(act);
    } else if (opcion == 9) {
      this.paginanotificaciones(act);
    } else if (opcion == 0) {
      let url = '';

      // Si es un mapa me construyo un link
      switch (act.tipo) {

        // link
        case 1:
          window.open(act.link, '_system', 'location=yes');
          break;

        // Mapa
        case 2:
          url = "https://www.google.com/maps/?q=" + act.latitud + "," + act.longitud;
          window.open(url, '_system', 'location=yes');
          break;

        // Teléfono
        case 3:
          url = "tel:" + act.link;
          window.open(url, '_system', 'location=yes');
          break;

        // Mail
        case 4:
          url = "mailto:" + act.link;
          window.open(url, '_system', 'location=yes');
          break;

      }
    }
  }

  paginacongreso(act) {
    this.navCtrl.push('page-congreso', { congresoactivo: this.global.congresomenu, menu: act });
  }

  paginaponentes(act) {
    this.navCtrl.push('page-ponentes', { congresoactivo: this.global.congresomenu, ponentes: this.misponentes, menu: act });
  }

  paginaprograma(act) {
    this.navCtrl.push('page-programa', { congresoactivo: this.global.congresomenu, programa: this.miprograma, menu: act });
  }

  paginadocumentos(act) {
    this.navCtrl.push('page-documentos', { congresoactivo: this.global.congresomenu, etiquetaselect: act.subopcion, menu: act });
  }

  paginalinks(act) {
    this.navCtrl.push('page-links', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginaencuestacab(act) {
    this.navCtrl.push('page-encuestacab', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginaencuesta(act) {
    this.navCtrl.push('page-encuesta', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginanotificaciones(act) {
    this.navCtrl.push('page-notificaciones', { congresoactivo: this.global.congresomenu, menu: act });
  }

  paginapatrocinadores(act) {
    console.log("pasa patrocinadores");
    this.navCtrl.push('page-patrocinadores', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginapreguntas(act) {
    this.navCtrl.push('page-preguntas', { congresoactivo: this.global.congresomenu, menu: act });
  }
  paginamenu() {
    this.navCtrl.push('page-menu', { congresoactivo: this.global.congresomenu });
  }
  cargaresultados() {

    setTimeout(() => {
      this.muestragrafico();
    }, 1000);


  }
  formatea_dato(x) {
    var string = x + '';
    var texto = string.split(',');

console.log(texto);
    //return (texto);
  }
  formatea_texto(x) {
    var string = x + '';
    var texto = string.split(',');
    console.log(texto);
   // return (texto);
    //console.log(x);
  }
  muestragrafico() {
    /*   this.barChart = new Chart(this.barCanvas1.nativeElement, {
    
         type: 'bar',
         data: {
             labels: ["A", "B", "C", "D", "E", "F"],
             datasets: [{
                 label: '',
                 data: ["1", "1", "1", "1", "1", "1"],
                 backgroundColor: [
                     'rgba(255, 99, 132, 0.2)',
                     'rgba(54, 162, 235, 0.2)',
                     'rgba(255, 206, 86, 0.2)',
                     'rgba(75, 192, 192, 0.2)',
                     'rgba(153, 102, 255, 0.2)',
                     'rgba(255, 159, 64, 0.2)'
                 ],
                 borderColor: [
                     'rgba(255,99,132,1)',
                     'rgba(54, 162, 235, 1)',
                     'rgba(255, 206, 86, 1)',
                     'rgba(75, 192, 192, 1)',
                     'rgba(153, 102, 255, 1)',
                     'rgba(255, 159, 64, 1)'
                 ],
                 borderWidth: 1
             }]
         },
         options: {
             scales: {
                 yAxes: [{
                     ticks: {
                         beginAtZero:true
                     }
                 }]
             }
         }
   
     });*/

  }
  copy(){
    
    let textarea = null;
    textarea = document.createElement("textarea");
    textarea.style.height = "0px";
    textarea.style.left = "-100px";
    textarea.style.opacity = "0";
    textarea.style.position = "fixed";
    textarea.style.top = "-100px";
    textarea.style.width = "0px";
    document.body.appendChild(textarea);
    // Set and select the value (creating an active Selection range).
    textarea.value = 'https://app.tactilevents.com/?'+this.global.congresomenu.nombre;
    textarea.select();
    // Ask the browser to copy the current selection to the clipboard.
    let successful = document.execCommand("copy");
    if (successful) {
      // do something
    } else {
      // handle the error
    }
    if (textarea && textarea.parentNode) {
      textarea.parentNode.removeChild(textarea);
    }
    const toast = this.toastCtrl.create({
      message: 'La url ha sido copiada',
      duration: 3000
    });
    toast.present();
  }
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }
}



// WEBPACK FOOTER //
// ./src/pages/panel/panel.ts